import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoakkalkotcab() {



const cardData = {
  keyword: " Pune to Akkalkot Cab ",

"headingDescription": "SRS Cab Service offers Pune to Akkalkot Cab, providing a safe, comfortable, and reliable travel solution for pilgrims and travelers visiting the holy town of Akkalkot. Our experienced drivers, well-maintained vehicles, and punctual service ensure a smooth and hassle-free journey from Pune to Akkalkot. Ideal for spiritual trips, family travel, and group visits, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a peaceful and convenient travel experience.",
"topPlaces": [
  {
    "title": "Akkalkot Swami Samarth Maharaj Temple",
    "description": "Akkalkot Swami Samarth Maharaj Temple is the main spiritual attraction dedicated to Shri Swami Samarth. Travelers using SRS Cab Service from Pune often visit this temple to seek blessings and experience divine peace."
  },
  {
    "title": "Vat Vruksha Mandir",
    "description": "Vat Vruksha Mandir is a sacred place where Swami Samarth is believed to have meditated under a banyan tree. Visitors using SRS Cab Service often spend time here for prayer and spiritual calmness."
  },
  {
    "title": "Samadhi Math",
    "description": "Samadhi Math is the resting place of Swami Samarth and an important pilgrimage site. Travelers using SRS Cab Service often include this location for devotion and meditation."
  },
  {
    "title": "Shree Swami Samarth Annachatra",
    "description": "Annachatra is a place where free meals are served to devotees. Visitors using SRS Cab Service often experience the spiritual tradition of community service here."
  },
  {
    "title": "Akkalkot Palace",
    "description": "Akkalkot Palace is a historic site associated with the royal family and Swami Samarth. Travelers using SRS Cab Service often explore this place for its historical and cultural significance."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is a popular religious site in Akkalkot. Visitors using SRS Cab Service often visit this temple to seek blessings and explore local traditions."
  },
  {
    "title": "Shivpuri",
    "description": "Shivpuri is a peaceful location near Akkalkot known for its spiritual environment. Travelers using SRS Cab Service often visit this place for relaxation and meditation."
  },
  {
    "title": "Ganagapur",
    "description": "Ganagapur is a nearby pilgrimage destination associated with Lord Dattatreya. Visitors using SRS Cab Service often extend their trip to include this sacred place."
  },
  {
    "title": "Solapur City",
    "description": "Solapur is a nearby city known for temples and cultural sites. Travelers using SRS Cab Service often explore Solapur as part of their Akkalkot journey."
  },
  {
    "title": "Great Indian Bustard Sanctuary",
    "description": "This wildlife sanctuary near Solapur is known for bird conservation. Visitors using SRS Cab Service often visit for nature exploration and wildlife experience."
  }
],



services: [
{
name: "Pune to Akkalkot Car Rental Price",
description: "Pune to Akkalkot car rental price provides detailed cost estimates for travel planning. Customers can check pricing before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with car rental services."
},
{
name: "Pune to Akkalkot Taxi",
description: "Pune to Akkalkot taxi offers convenient travel for temple visits. Customers can book taxis for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Akkalkot with taxi services."
},
{
name: "Pune to Akkalkot Cabs",
description: "Pune to Akkalkot cabs provide reliable transportation for long-distance travel. Customers can book cabs for darshan trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Tuljapur Cab Fare",
description: "Pune to Tuljapur cab fare offers detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Tuljapur Car Rental",
description: "Pune to Tuljapur car rental provides flexible travel options for temple visits. Customers can rent cars for family trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Pune to Tuljapur Cab",
description: "Pune to Tuljapur cab offers convenient transportation for pilgrimage trips. Customers can book cabs for darshan journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Solapur Cab",
description: "Pune to Solapur cab provides reliable intercity travel for business and leisure. Customers can book cabs for long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Solapur One Way Cab",
description: "Pune to Solapur one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way cab services."
},
{
name: "Pune to Pandharpur Cab",
description: "Pune to Pandharpur cab offers comfortable travel for temple visits. Customers can book cabs for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Pandharpur with cab services."
},
{
name: "Pune to Pandharpur Cab Service",
description: "Pune to Pandharpur cab service provides dependable travel for devotees. Customers can book cabs for darshan trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Pandharpur Car Rental",
description: "Pune to Pandharpur car rental offers flexible vehicle options for travel. Customers can rent cars for family trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily for Pandharpur travel."
},
{
name: "Pune to Pandharpur Taxi",
description: "Pune to Pandharpur taxi provides convenient transportation for temple visits. Customers can book taxis for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Gangapur Cab",
description: "Pune to Gangapur cab offers reliable travel for temple visits. Customers can book cabs for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Akkalkot Cab Service",
description: "Pune to Akkalkot cab service provides dependable transportation for long-distance travel. Customers can book cabs for darshan trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Akkalkot Taxi Service",
description: "Pune to Akkalkot taxi service offers convenient travel for temple visits. Customers can book taxis for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Akkalkot Cab Booking",
description: "Pune to Akkalkot cab booking provides quick and easy reservation options. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Akkalkot Taxi Booking",
description: "Pune to Akkalkot taxi booking offers convenient booking options for travelers. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Pune to Akkalkot One Way Cab",
description: "Pune to Akkalkot one way cab offers economical travel for direct journeys. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way cab services."
},
{
name: "Pune to Akkalkot One Way Taxi",
description: "Pune to Akkalkot one way taxi provides convenient travel for single-direction trips. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way taxi services."
},
{
name: "Pune to Akkalkot Cab Fare",
description: "Pune to Akkalkot cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Akkalkot Taxi Price",
description: "Pune to Akkalkot taxi price offers clear pricing details for travelers. Customers can check rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent pricing."
},
{
name: "Pune to Akkalkot Cab Hire",
description: "Pune to Akkalkot cab hire offers flexible travel solutions for long-distance trips. Customers can hire vehicles for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire cabs easily from Pune."
},
{
name: "Pune to Akkalkot Taxi Hire",
description: "Pune to Akkalkot taxi hire provides convenient transportation for temple visits. Customers can hire taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi hire services."
},
{
name: "Pune to Akkalkot Outstation Cab",
description: "Pune to Akkalkot outstation cab offers reliable travel for long-distance journeys. Customers can book cabs for one-way or round trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
}
],

tableData: [
["Pune to Akkalkot Car Rental Price","Pune to Akkalkot Taxi"],
["Pune to Akkalkot Cabs","Pune to Tuljapur Cab Fare"],
["Pune to Tuljapur Car Rental","Pune to Tuljapur Cab"],
["Pune to Solapur Cab","Pune to Solapur One Way Cab"],
["Pune to Pandharpur Cab","Pune to Pandharpur Cab Service"],
["Pune to Pandharpur Car Rental","Pune to Pandharpur Taxi"],
["Pune to Gangapur Cab","Pune to Akkalkot Cab Service"],
["Pune to Akkalkot Taxi Service","Pune to Akkalkot Cab Booking"],
["Pune to Akkalkot Taxi Booking","Pune to Akkalkot One Way Cab"],
["Pune to Akkalkot One Way Taxi","Pune to Akkalkot Cab Fare"],
["Pune to Akkalkot Taxi Price","Pune to Akkalkot Cab Hire"],
["Pune to Akkalkot Taxi Hire","Pune to Akkalkot Outstation Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with Pune to Akkalkot routes, ensuring safe driving and a smooth journey for temple visits."
  },
  {
    WhyChooseheading: "Affordable Pune to Akkalkot Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Akkalkot cab services with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service for Darshan Travel",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Akkalkot cab bookings, making it convenient for early morning darshan, same-day return, and flexible travel plans."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable and peaceful journey to Akkalkot."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized Akkalkot darshan packages from Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for family and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Akkalkot Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Akkalkot cab bookings due to punctual drivers, reliable vehicles, and smooth pilgrimage travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Akkalkot cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Akkalkot for temple visits." },
  { question: "How far is Akkalkot from Pune?", answer: "The distance between Pune and Akkalkot is approximately 300 km and the journey takes around 6 to 7 hours." },
  { question: "Is Pune to Akkalkot cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Akkalkot trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Akkalkot?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide same-day return for Akkalkot?", answer: "Yes, we offer same-day return packages for Akkalkot darshan from Pune." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Akkalkot cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Kulkarni",
    feedback:
      "Booked SRS Cab Service for Akkalkot darshan. Smooth journey and very comfortable ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Patil",
    feedback:
      "Excellent Pune to Akkalkot cab service. Perfect for family pilgrimage trip.",
    rating: 5
  }
];





























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Akkalkot Cab | SRS Cab",
  "description": "Book Pune to Akkalkot cab with SRS Cab. One-way, round trips, cab booking, and car rentals available. Affordable taxi services including Innova, Dzire, and private cars for safe and comfortable travel with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2350"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune to Akkalkot Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="SRS Cab offers Pune to Akkalkot cab services including one-way and round trips, car rentals, and private taxi bookings. Affordable rates, safe and comfortable rides with Innova, Dzire, and online 24x7 booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoakkalkotcab;